import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { FiEye, FiInfo } from "react-icons/fi";
import { getTrainingManagementStatusClass, TM_STATUS } from "../CONSTANTS";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { ACTIVE_MODULE } from "app/_constants/constant";
// import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import FormField from "app/Components/Form/FormField.component";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { isUserVTO } from "../../IncidentManagement/Helper";
import {
  TRAINING_STATUS,
  TRAINEE_TYPE,
  TRAINING_STATUS_VIEW,
  trainingStatusFilterFields,
} from "../CONSTANTS";
import { getAllTrainingAssigners } from "app/_services/ehs/ehsTrainingServices";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import { useForm } from "app/_helpers/hooks";
import TrainingStatusFilters from "../Assign/Component/TrainingStatusFilters";
import { validateRowFilter } from "../../IncidentManagement/CONSTANTS";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { downloadFileByURL } from "app/_helpers/reactHelper";
import { capitalize } from "lodash";
import { capitalizeName } from "app/_helpers/helper";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
import { useLocation } from "react-router-dom";

const TrainingStatus = ({
  match: {
    params: { siteId },
  },
}) => {
  const [trainings, setTrainings] = useState([]);
  const [tableVFLList, setTableVFLList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const downloadPdf = async (id) => {
    // const data = await downloadMedicalCertificate(id);
    downloadFileByURL(
      URL_CONFIG.DEV_URL +
        "global-configuration/ehs-module/download-training-certificate/" +
        id,
      `training-certificate-${new Date().toISOString()}.pdf`
    );
  };

  const onReset = () => setFilterForm({ batchName: "", traineeDesignation: "" });

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "traineeTypeView") {
        prev.traineeId = "";
      }
      return { ...prev, [name]: value };
    });
  };

  const [sort, setSort] = useState({ order: "asc", dataField: "" });

  const tableContainerRef = useRef(null);

  const onTableChange = (actionType, { sortField: dataField, sortOrder: order }) => {
    if (actionType !== "sort") return;

    setSort({ dataField, order });
    setTableVFLList((prev) => {
      const newRows = [...prev].sort((a, b) => {
        if (order === "asc") return a[dataField] > b[dataField] ? -1 : 1;
        else return a[dataField] < b[dataField] ? -1 : 1;
      });

      return newRows;
    });
  };

  // ******** useMemo ******
  const sortableColumn = useMemo(() => {
    const column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "locationName",
        text: "Location",
        sort: true,
      },
      {
        dataField: "traineeTypeView",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "traineeID",
        text: "ID",
        sort: true,
      },
      {
        dataField: "traineeName",
        text: "Name",
        sort: true,
        formatter: (index, row) => {
          return <div>{capitalizeName(row?.traineeName)}</div>;
        },
      },
      {
        dataField: "traineeDesignation",
        text: "Designation",
        sort: true,
      },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },
      {
        dataField: "trainingTypeView",
        text: "Training Type",
        sort: true,
      },
      {
        dataField: "trainingCategoryName",
        text: "Skill Category",
        sort: true,
      },
      // {
      //   dataField: "trainingSubCategoryName",
      //   text: "Training Sub-Category",
      //   sort: true,
      // },
      {
        dataField: "ehsSite.name",
        text: "Mines name",
        sort: true,
      },
      {
        dataField: "startDate",
        text: "Start Date",
        sort: true,
        formatter: (startDate) => {
          return DDMMYYYYFormat(startDate);
        },
      },
      {
        dataField: "batchName",
        text: "Batch ID",
        sort: true,
      },
      {
        dataField: "trainingStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return <div className={getTrainingManagementStatusClass(status)}>{status}</div>;
        },
      },
      {
        dataField: "certificateId",
        text: "Certificate",
        sort: true,
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              {row?.trainingStatus === TRAINING_STATUS.completed && isUserVTO() ? (
                <CustomTooltip tooltip={"Certificate"}>
                  <span
                    onClick={() => downloadPdf(row?.id)}
                    className="icons text-cyanBlue"
                  >
                    <FiInfo style={{ color: "rgb(21 239 21)" }} />
                  </span>
                </CustomTooltip>
              ) : (
                "In Progress"
              )}
            </div>
          );
        },
      },
      {
        dataField: "ID",
        text: "Action",
        sort: true,
        formatter: (cell, row) => {
          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={`${
                    siteId ? "/sites/" + siteId : ""
                  }/health-safety-and-environment/training-management/view/${row.id}`}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>
            </div>
          );
        },
      },
    ];

    return column;
  }, [siteId]);

  // useEffect(() => {
  //   getAllTrainingAssigners(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
  //     if (!response?.data) return;

  //     setTrainings(
  //       Array.isArray(response?.data)
  //         ? response?.data.map((data) => ({
  //             ...data,
  //             locationName: data?.ehsSite ? data?.ehsSite?.name : "",
  //           }))
  //         : []
  //     );
  //   });
  // }, [siteId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getAllTrainingAssigners("activeAssigneeTraining");

        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        setTrainings(
          Array.isArray(response?.data)
            ? response?.data.map((data) => ({
                ...data,
                locationName: data?.ehsSite ? data?.ehsSite?.name : "",
              }))
            : []
        );
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };
    fetchData();
  }, [siteId]);

  useEffect(() => {
    setTableVFLList(
      trainings?.filter?.((data) => {
        let flag = true;
        if (filterForm?.traineeTypeView === "All") flag = true;

        if (flag) {
          for (const key in filterForm) {
            if (
              (key === "traineeTypeView" && filterForm?.traineeTypeView === "All") ||
              !filterForm[key]
            )
              continue;
            if (
              key !== "traineeDesignation" &&
              key !== "batchName" &&
              data[key] !== filterForm[key]
            )
              return (flag = false);
            else if (
              (key === "traineeDesignation" || key === "batchName") &&
              !data[key]?.toLowerCase()?.includes(filterForm[key]?.toLowerCase())
            )
              return (flag = false);
          }

          return (flag = true);
        }

        // if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, trainings]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <TrainingStatusFilters
        fields={trainingStatusFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Training Management",
            path: "/health-safety-and-environment/training-management",
          },
          { name: "Training Status" },
        ]}
        module={ACTIVE_MODULE.training}
      />
      <div className="p-2">
        <div className="card p-3 mt-3" ref={tableContainerRef}>
          <div className="simple-card-title">
            <h3 className="text-capitalize mb-1">Training Status</h3>
            <FilterBtn setShowFilter={setShowFilter} />

            <BackBtn url="/health-safety-and-environment/training-management" />
          </div>
          <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-2">
            <div className="hseMenuLinks card">
              <Link
                to={"/health-safety-and-environment/training-management/status"}
                className={`pointer${
                  location?.pathname.split("/")?.includes("status") ? " active" : ""
                }`}
              >
                Training Data - Workflow Generated
              </Link>
              <Link
                to={"/health-safety-and-environment/training-management/all-training"}
                className={`pointer${
                  location?.pathname.split("/")?.includes("all-training") ? " active" : ""
                }`}
              >
                Training Data - All
              </Link>
            </div>
          </div>
          {!loading ? (
            <SearchBootstrapTable
              searchKey={"trainingStatusDesktopSearch"}
              data={tableVFLList.map((d, idx) => ({ ...d, sid: idx + 1 }))}
              columns={sortableColumn}
              onTableChange={onTableChange}
              sort={sort}
              remote={{
                sort: true,
              }}
              tableBeforeSearch={tableToolbarBeforeView}
              tableKey={"trainingStatus"}
            />
          ) : (
            <NetZeroLoader />
          )}
        </div>
      </div>
    </>
  );
};

export default TrainingStatus;
